import { Flex } from "@chakra-ui/react";
import { CategoryImpressionsTable } from "../categoryImpressionsTable";
import {
  BrandChoicesEnum,
  BreakdownTypeEnum,
  InsightsDistributionByAdvertiser,
} from "../../../graphqlExternal/generated";
import { DateRangeBox } from "../dateRangeBox";
import { getAppleAdvertiserName, getBayerAdvertiserName, getDemoAdvertiserName } from "../../../utils/displayGetters";
import { BrandChoicesOptionsType, unsafeRateName } from "..";

export interface AdvertiserDistributionProps {
  breakdownType: BreakdownTypeEnum;
  localBrandFilter?: BrandChoicesOptionsType | undefined;
  advertiserDistribution: InsightsDistributionByAdvertiser[];
  startDate: string;
  endDate: string;
}

export const AdvertiserDistribution = (
  advertiserDistribution: AdvertiserDistributionProps
) => {
  const advertiserDataList: InsightsDistributionByAdvertiser[] = [];

  advertiserDistribution?.advertiserDistribution.map((advertiser) => {
    const { __typename, ...advertiserData } = advertiser;

    // assign advertiser name based on id
    const newAdvertiserData: InsightsDistributionByAdvertiser = Object.assign(
      {},
      advertiserData
    );
    newAdvertiserData.advertiserName = determineAdvertiserName(advertiserDistribution.localBrandFilter,
      advertiser.advertiserId
    );

    // build object with keys in the desired order
    const ordered: InsightsDistributionByAdvertiser = {
      advertiserId: newAdvertiserData.advertiserId,
      advertiserName: newAdvertiserData.advertiserName,
      totalImpressions: newAdvertiserData.totalImpressions,
      brandUnsafeRate: newAdvertiserData.brandUnsafeRate,
      aggregationDate: advertiser.aggregationDate, 
    };

    advertiserDataList.push(ordered);
  });

  const dataTableProps = {
    data: advertiserDataList,
    columns: [
      "Advertiser ID",
      "Advertiser Name",
      "Total Impressions",
      // add dynamic unsafe rate name based on breakdown type
      unsafeRateName(advertiserDistribution.breakdownType) + " Unsafe Rate (%)",
    ],
    breakdownType: advertiserDistribution.breakdownType,
  };

  return (
    <Flex direction={"column"} mt={10} mb={10}>
      <Flex width={"99%"}>
        <DateRangeBox
          twoWeeksAgoDate={advertiserDistribution?.startDate}
          endDate={advertiserDistribution?.endDate}
        />
      </Flex>
      <Flex width={"100%"} justify={"center"}>
        <CategoryImpressionsTable dataTableProps={dataTableProps}/>
      </Flex>
    </Flex>
  );
};


export const determineAdvertiserName = (brand: BrandChoicesOptionsType | undefined, advertiserId: string) => {
  switch (brand?.value) {
    case BrandChoicesEnum.AppleTv:
      return getAppleAdvertiserName(advertiserId);
    case BrandChoicesEnum.Bayer:
      return getBayerAdvertiserName(advertiserId);
    case BrandChoicesEnum.Demo:
      return getDemoAdvertiserName(advertiserId);
    default:
      return "Unknown Advertiser";
  }
}